import React from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head, Link } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import Calendar from 'react-calendar';
import '../../css/calendar.css';
import { ScheduleCreation } from '../Components/ScheduleCreation';
import { DateTime } from 'luxon';



function Schedule({schedule, branchOffice}) {
    return (

            <Link
                href={route('schedule.show', {
                    schedule: schedule.id,
                    office: branchOffice.slug
                })}
                className="bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 flex flex-col sm:flex-row sm:justify-between sm:items-center hover:bg-gray-200 hover:border-gray-300"
                >
                    <div className='text-2xl font-bold'>
                        {schedule.time} hrs.
                    </div>
                    <div className='flex gap-2 text-gray-600'>
                        <span className="flex gap-3 text-center" title={`${schedule?.usedQuota.quantity} usados, ${schedule.quota} en total.`}>
                            <div>
                                <div>
                                    Cumpleaños
                                </div>
                                <div>
                                {schedule?.usedQuota.birthday_quantity}/{schedule.birthday_limit}
                                </div>
                            </div>
                            <div>
                                <div>
                                    Total
                                </div>
                                <div>
                                    {schedule?.usedQuota.quantity}/{schedule.quota}
                                </div>
                            </div>
                            {/* 🧑 {schedule.usedQuota.adults}/{schedule.adultsQuota} cupos a ${schedule.adultsPrice} */}
                        </span>
                        {/* {
                            !!schedule.childrenQuota &&
                            <span title={`Niños: ${schedule.usedQuota.children} usados, ${schedule.childrenQuota} en total.`}>
                                👶 {schedule.usedQuota.children}/{schedule.childrenQuota} cupos a ${schedule.childrenPrice}
                            </span>
                        } */}
                    </div>
            </Link>

    )
}

export default function IndexSchedule({branchOffice, branchOffices, roles, ...props}) {
    //console.log('datos de index schedule')
    const changeDate = v => {
        Inertia.visit(route('schedule.index', {
            date: v.toISOString().slice(0, 10),
            office: branchOffice.slug
        }))
    }

    const adminRole = roles.find(e => e.name === 'admin' || e.name === 'super_admin')
    const isSuperAdmin = roles.find(e => e.name === 'super_admin')
    //console.log(adminRole)
    return (
        <Authenticated
            store={props.store}
            auth={props.auth}
            errors={props.errors}
            branchOffice={branchOffice}
            branchOffices={branchOffices}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Agenda: {props.formatedDate}</h2>}
        >
            <Head title="Menú principal"/>

            <div className="max-w-7xl flex flex-col md:flex-row py-12 px-3 sm:px-6 lg:px-8 gap-8 mx-auto">

                <div className='lg:w-1/5 md:w-full grid grid-cols-1 sm:grid-cols-2 gap-5 lg:block'>
                    <div className='bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 '>
                        <Calendar defaultValue={DateTime.fromFormat(props.date, 'yyyy-MM-dd').toJSDate()} date={props.date} onChange={changeDate}/>
                    </div>
                    { isSuperAdmin && <ScheduleCreation branchOffice={branchOffice} store={props.store} presets={props.presets} /> }
                    
                </div>

                <div className="sm:w-4/5 md:w-1/2 flex-col flex gap-3">
                    {
                        props.schedule.sort((a, b) => {
                            const hour = {
                                a: DateTime.fromFormat(a.time, 'HH:mm').hour,
                                b: DateTime.fromFormat(b.time, 'HH:mm').hour
                            };

                            console.log({ a, hour })

                            if (hour.a > hour.b) {
                                return 1;
                            }

                            if (hour.a < hour.b) {
                                return -1;
                            }

                            return 0;
                        }).map(s => <Schedule branchOffice={branchOffice} store={props.store} schedule={s} key={s.id} />)
                    }
                    {
                        !!props.schedule.length &&
                        <div className='text-right text-gray-900 mt-5'>
                            <span>
                                Total del día: <span className='font-bold'>$ {props.dayBalance}</span>.
                            </span>
                            <span className='ml-1'>
                                Tickets vendidos: <span className='font-bold'> {props.totalTickets}</span>.
                            </span>
                            <span className='ml-1'>
                                Tickets validados: <span className='font-bold'> {props.validatedTickets}</span>.
                            </span>
                        </div>
                    }
                    {
                        !props.schedule.length &&
                        <div className='text-xl text-center font-bold text-gray-600'>
                            No existen horas creadas para este día.
                        </div>
                    }
                </div>

            </div>
        </Authenticated>
    );
}
